var menuToggle = document.querySelector('.js-menu-toggle') 
var menuTarget = document.querySelector('.user-layout') 
if (menuToggle) {
	menuToggle.onclick = function() {
		menuTarget.classList.toggle('user-layout--wide');
	};
}


document.onreadystatechange = function() {
	switch (document.readyState) {
		case 'loading':
			// The document is still loading.
			break;
		case 'interactive':
			// The document has finished loading. We can now access the DOM elements.
			// But sub-resources such as images, stylesheets and frames are still loading.
			// Equivalent of document.ready
			break;
		case 'complete':
			// The page is fully loaded.
			// Equivalent of window.load
			$app.notifications();
			break;
	}
};

// Resize event
window.addEventListener('resize', function(event){
	// Example
	// if ($app.wW() >= $app.breakpoints().small) {}
});

// Utilities and behaviours namespaced to $app
// use these functions by calling $app.method();
var $app = {
	// Allows you to query the window width against the breakpoints. These MUST match breakpoints
	// set in _vars.scss

	// Example
	//
	// if ($app.wW() >= $app.breakpoints().small) {
	//  code to run when the window hits large breakpoint
	// }
	//
	breakpoints: function() {
		obj = {
			'xsmall':	'460',
			'small': 	'640',
			'medium':	'768',
			'large':	'1024',
			'xlarge':	'1280',
			'xxlarge':	'1600'
		}

		return obj;
	},

	wW: function(){
		return window.innerWidth;
	},

	// function for setting cookies
	setCookie: function(name,value,days) {
		var expires = "";
		if (days) {
			var date = new Date();
			date.setTime(date.getTime() + (days*24*60*60*1000));
			expires = "; expires=" + date.toUTCString();
		}
		document.cookie = name + "=" + (value || "")  + expires + "; path=/";
	},

	// function for getting cookies
	getCookie: function(name) {
		var nameEQ = name + "=";
		var ca = document.cookie.split(';');
		for(var i=0;i < ca.length;i++) {
			var c = ca[i];
			while (c.charAt(0)==' ') c = c.substring(1,c.length);
			if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
		}
		return null;
	},

	// function to erase a cookie
	eraseCookie: function(name) {
		document.cookie = name+'=; Max-Age=-99999999;';
	},

	// notification handler
	notifications: function() {
		const notifications = document.querySelectorAll('.js-notification');
		setTimeout(function() {
			Array.from(notifications, function(notification) {
				notification.classList.add('notification--hide');
			});
		}, 5000);
	}

} // end of $app